/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: trade.fga
 * Run: pnpm run gen:permissions -- trade
 */

import type { ModulePermissions } from './types';

export const tradePermissions = {
  module: 'trade',
  displayName: 'Trade',
  entities: [
    {
      name: 'booking',
      displayName: 'Booking',
      permissions: [
        { key: 'bookingRead', action: 'Read', category: 'crud' },
        { key: 'bookingCreate', action: 'Create', category: 'crud' },
        { key: 'bookingUpdate', action: 'Update', category: 'crud' },
        { key: 'bookingDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'bookingCustomer',
      displayName: 'Booking Customer',
      permissions: [
        { key: 'bookingCustomerRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'brokeredOrder',
      displayName: 'Brokered Order',
      permissions: [
        { key: 'brokeredOrderRead', action: 'Read', category: 'crud' },
        { key: 'brokeredOrderCreate', action: 'Create', category: 'crud' },
        { key: 'brokeredOrderUpdate', action: 'Update', category: 'crud' },
        { key: 'brokeredOrderDelete', action: 'Delete', category: 'crud' },
        { key: 'brokeredOrderClose', action: 'Close', category: 'custom' },
        { key: 'brokeredOrderFulfill', action: 'Fulfill', category: 'custom' },
        {
          key: 'brokeredOrderInProgress',
          action: 'In Progress',
          category: 'custom',
        },
        {
          key: 'brokeredOrderLinkOrders',
          action: 'Link Orders',
          category: 'custom',
        },
        { key: 'brokeredOrderOpen', action: 'Open', category: 'custom' },
        { key: 'brokeredOrderVoid', action: 'Void', category: 'custom' },
      ],
    },
    {
      name: 'brokeredOrderLineItem',
      displayName: 'Brokered Order Line Item',
      permissions: [
        { key: 'brokeredOrderLineItemRead', action: 'Read', category: 'crud' },
        {
          key: 'brokeredOrderLineItemCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'brokeredOrderLineItemUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'brokeredOrderLineItemDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'complianceCheck',
      displayName: 'Compliance Check',
      permissions: [
        { key: 'complianceCheckRead', action: 'Read', category: 'crud' },
        { key: 'complianceCheckUpdate', action: 'Update', category: 'crud' },
        {
          key: 'complianceCheckOverride',
          action: 'Override',
          category: 'custom',
        },
      ],
    },
    {
      name: 'complianceHold',
      displayName: 'Compliance Hold',
      permissions: [
        { key: 'complianceHoldRead', action: 'Read', category: 'crud' },
        { key: 'complianceHoldUpdate', action: 'Update', category: 'crud' },
        { key: 'complianceHoldExtend', action: 'Extend', category: 'custom' },
        {
          key: 'complianceHoldFlagPolice',
          action: 'Flag Police',
          category: 'custom',
        },
        { key: 'complianceHoldRelease', action: 'Release', category: 'custom' },
      ],
    },
    {
      name: 'container',
      displayName: 'Container',
      permissions: [
        { key: 'containerRead', action: 'Read', category: 'crud' },
        { key: 'containerCreate', action: 'Create', category: 'crud' },
        { key: 'containerUpdate', action: 'Update', category: 'crud' },
        { key: 'containerDelete', action: 'Delete', category: 'crud' },
        { key: 'containerRoll', action: 'Roll', category: 'custom' },
        {
          key: 'containerTransition',
          action: 'Transition',
          category: 'custom',
        },
      ],
    },
    {
      name: 'deductionType',
      displayName: 'Deduction Type',
      permissions: [
        { key: 'deductionTypeRead', action: 'Read', category: 'crud' },
        { key: 'deductionTypeCreate', action: 'Create', category: 'crud' },
        { key: 'deductionTypeUpdate', action: 'Update', category: 'crud' },
        { key: 'deductionTypeDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'defaultPhotoRequirement',
      displayName: 'Default Photo Requirement',
      permissions: [
        {
          key: 'defaultPhotoRequirementRead',
          action: 'Read',
          category: 'crud',
        },
        {
          key: 'defaultPhotoRequirementCreate',
          action: 'Create',
          category: 'crud',
        },
      ],
    },
    {
      name: 'itemAlias',
      displayName: 'Item Alias',
      permissions: [
        { key: 'itemAliasRead', action: 'Read', category: 'crud' },
        { key: 'itemAliasCreate', action: 'Create', category: 'crud' },
        { key: 'itemAliasUpdate', action: 'Update', category: 'crud' },
        { key: 'itemAliasDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'itemPosition',
      displayName: 'Item Position',
      permissions: [
        { key: 'itemPositionRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'load',
      displayName: 'Load',
      permissions: [
        { key: 'loadRead', action: 'Read', category: 'crud' },
        { key: 'loadCreate', action: 'Create', category: 'crud' },
        { key: 'loadUpdate', action: 'Update', category: 'crud' },
        { key: 'loadDelete', action: 'Delete', category: 'crud' },
        { key: 'loadReceive', action: 'Receive', category: 'custom' },
        { key: 'loadReconcile', action: 'Reconcile', category: 'custom' },
        { key: 'loadShip', action: 'Ship', category: 'custom' },
      ],
    },
    {
      name: 'loadCustomer',
      displayName: 'Load Customer',
      permissions: [
        { key: 'loadCustomerRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'loadDeduction',
      displayName: 'Load Deduction',
      permissions: [
        { key: 'loadDeductionRead', action: 'Read', category: 'crud' },
        { key: 'loadDeductionCreate', action: 'Create', category: 'crud' },
        { key: 'loadDeductionUpdate', action: 'Update', category: 'crud' },
        { key: 'loadDeductionDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'loadReconciliation',
      displayName: 'Load Reconciliation',
      permissions: [
        { key: 'loadReconciliationRead', action: 'Read', category: 'crud' },
        { key: 'loadReconciliationUpdate', action: 'Update', category: 'crud' },
        { key: 'loadReconciliationDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'locationFreightPricing',
      displayName: 'Location Freight Pricing',
      permissions: [
        { key: 'locationFreightPricingRead', action: 'Read', category: 'crud' },
        {
          key: 'locationFreightPricingCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'locationFreightPricingUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'locationFreightPricingDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'purchaseLoad',
      displayName: 'Purchase Load',
      permissions: [
        { key: 'purchaseLoadRead', action: 'Read', category: 'crud' },
        { key: 'purchaseLoadCreate', action: 'Create', category: 'crud' },
        { key: 'purchaseLoadUpdate', action: 'Update', category: 'crud' },
        { key: 'purchaseLoadDelete', action: 'Delete', category: 'crud' },
        { key: 'purchaseLoadClose', action: 'Close', category: 'custom' },
        {
          key: 'purchaseLoadCompleteInventory',
          action: 'Complete Inventory',
          category: 'custom',
        },
        {
          key: 'purchaseLoadCompletePrice',
          action: 'Complete Price',
          category: 'custom',
        },
        { key: 'purchaseLoadHold', action: 'Hold', category: 'custom' },
        { key: 'purchaseLoadPay', action: 'Pay', category: 'custom' },
        { key: 'purchaseLoadRelease', action: 'Release', category: 'custom' },
        { key: 'purchaseLoadVoid', action: 'Void', category: 'custom' },
      ],
    },
    {
      name: 'purchaseLoadDeduction',
      displayName: 'Purchase Load Deduction',
      permissions: [
        { key: 'purchaseLoadDeductionRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'purchaseLoadLineItem',
      displayName: 'Purchase Load Line Item',
      permissions: [
        { key: 'purchaseLoadLineItemRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'purchaseLoadPayment',
      displayName: 'Purchase Load Payment',
      permissions: [
        { key: 'purchaseLoadPaymentRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'purchaseOrder',
      displayName: 'Purchase Order',
      permissions: [
        { key: 'purchaseOrderRead', action: 'Read', category: 'crud' },
        { key: 'purchaseOrderCreate', action: 'Create', category: 'crud' },
        { key: 'purchaseOrderUpdate', action: 'Update', category: 'crud' },
        { key: 'purchaseOrderDelete', action: 'Delete', category: 'crud' },
        { key: 'purchaseOrderClose', action: 'Close', category: 'custom' },
        { key: 'purchaseOrderFinish', action: 'Finish', category: 'custom' },
        { key: 'purchaseOrderReopen', action: 'Reopen', category: 'custom' },
        { key: 'purchaseOrderVoid', action: 'Void', category: 'custom' },
      ],
    },
    {
      name: 'purchaseOrderFreight',
      displayName: 'Purchase Order Freight',
      permissions: [
        { key: 'purchaseOrderFreightRead', action: 'Read', category: 'crud' },
        {
          key: 'purchaseOrderFreightCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'purchaseOrderFreightUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'purchaseOrderFreightDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'purchaseOrderLineItem',
      displayName: 'Purchase Order Line Item',
      permissions: [
        { key: 'purchaseOrderLineItemRead', action: 'Read', category: 'crud' },
        {
          key: 'purchaseOrderLineItemCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'purchaseOrderLineItemUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'purchaseOrderLineItemDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'quote',
      displayName: 'Quote',
      permissions: [
        { key: 'quoteRead', action: 'Read', category: 'crud' },
        { key: 'quoteCreate', action: 'Create', category: 'crud' },
        { key: 'quoteUpdate', action: 'Update', category: 'crud' },
        { key: 'quoteDelete', action: 'Delete', category: 'crud' },
        { key: 'quoteAccept', action: 'Accept', category: 'custom' },
        { key: 'quoteClone', action: 'Clone', category: 'custom' },
        { key: 'quoteConvert', action: 'Convert', category: 'custom' },
        { key: 'quoteReject', action: 'Reject', category: 'custom' },
        { key: 'quoteRestore', action: 'Restore', category: 'custom' },
        {
          key: 'quoteRevertToOpen',
          action: 'Revert To Open',
          category: 'custom',
        },
        { key: 'quoteSend', action: 'Send', category: 'custom' },
        { key: 'quoteVoid', action: 'Void', category: 'custom' },
      ],
    },
    {
      name: 'quoteLineItem',
      displayName: 'Quote Line Item',
      permissions: [
        { key: 'quoteLineItemRead', action: 'Read', category: 'crud' },
        { key: 'quoteLineItemCreate', action: 'Create', category: 'crud' },
        { key: 'quoteLineItemUpdate', action: 'Update', category: 'crud' },
        { key: 'quoteLineItemDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'salesOrder',
      displayName: 'Sales Order',
      permissions: [
        { key: 'salesOrderRead', action: 'Read', category: 'crud' },
        { key: 'salesOrderCreate', action: 'Create', category: 'crud' },
        { key: 'salesOrderUpdate', action: 'Update', category: 'crud' },
        { key: 'salesOrderDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'salesOrderCustomer',
      displayName: 'Sales Order Customer',
      permissions: [
        { key: 'salesOrderCustomerRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'salesOrderFreight',
      displayName: 'Sales Order Freight',
      permissions: [
        { key: 'salesOrderFreightRead', action: 'Read', category: 'crud' },
        { key: 'salesOrderFreightCreate', action: 'Create', category: 'crud' },
        { key: 'salesOrderFreightUpdate', action: 'Update', category: 'crud' },
        { key: 'salesOrderFreightDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'ticketFreight',
      displayName: 'Ticket Freight',
      permissions: [
        { key: 'ticketFreightRead', action: 'Read', category: 'crud' },
        { key: 'ticketFreightCreate', action: 'Create', category: 'crud' },
        { key: 'ticketFreightUpdate', action: 'Update', category: 'crud' },
        { key: 'ticketFreightDelete', action: 'Delete', category: 'crud' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Trade module
 */
export type TradePermissionKey =
  | 'bookingRead'
  | 'bookingCreate'
  | 'bookingUpdate'
  | 'bookingDelete'
  | 'bookingCustomerRead'
  | 'brokeredOrderRead'
  | 'brokeredOrderCreate'
  | 'brokeredOrderUpdate'
  | 'brokeredOrderDelete'
  | 'brokeredOrderClose'
  | 'brokeredOrderFulfill'
  | 'brokeredOrderInProgress'
  | 'brokeredOrderLinkOrders'
  | 'brokeredOrderOpen'
  | 'brokeredOrderVoid'
  | 'brokeredOrderLineItemRead'
  | 'brokeredOrderLineItemCreate'
  | 'brokeredOrderLineItemUpdate'
  | 'brokeredOrderLineItemDelete'
  | 'complianceCheckRead'
  | 'complianceCheckUpdate'
  | 'complianceCheckOverride'
  | 'complianceHoldRead'
  | 'complianceHoldUpdate'
  | 'complianceHoldExtend'
  | 'complianceHoldFlagPolice'
  | 'complianceHoldRelease'
  | 'containerRead'
  | 'containerCreate'
  | 'containerUpdate'
  | 'containerDelete'
  | 'containerRoll'
  | 'containerTransition'
  | 'deductionTypeRead'
  | 'deductionTypeCreate'
  | 'deductionTypeUpdate'
  | 'deductionTypeDelete'
  | 'defaultPhotoRequirementRead'
  | 'defaultPhotoRequirementCreate'
  | 'itemAliasRead'
  | 'itemAliasCreate'
  | 'itemAliasUpdate'
  | 'itemAliasDelete'
  | 'itemPositionRead'
  | 'loadRead'
  | 'loadCreate'
  | 'loadUpdate'
  | 'loadDelete'
  | 'loadReceive'
  | 'loadReconcile'
  | 'loadShip'
  | 'loadCustomerRead'
  | 'loadDeductionRead'
  | 'loadDeductionCreate'
  | 'loadDeductionUpdate'
  | 'loadDeductionDelete'
  | 'loadReconciliationRead'
  | 'loadReconciliationUpdate'
  | 'loadReconciliationDelete'
  | 'locationFreightPricingRead'
  | 'locationFreightPricingCreate'
  | 'locationFreightPricingUpdate'
  | 'locationFreightPricingDelete'
  | 'purchaseLoadRead'
  | 'purchaseLoadCreate'
  | 'purchaseLoadUpdate'
  | 'purchaseLoadDelete'
  | 'purchaseLoadClose'
  | 'purchaseLoadCompleteInventory'
  | 'purchaseLoadCompletePrice'
  | 'purchaseLoadHold'
  | 'purchaseLoadPay'
  | 'purchaseLoadRelease'
  | 'purchaseLoadVoid'
  | 'purchaseLoadDeductionRead'
  | 'purchaseLoadLineItemRead'
  | 'purchaseLoadPaymentRead'
  | 'purchaseOrderRead'
  | 'purchaseOrderCreate'
  | 'purchaseOrderUpdate'
  | 'purchaseOrderDelete'
  | 'purchaseOrderClose'
  | 'purchaseOrderFinish'
  | 'purchaseOrderReopen'
  | 'purchaseOrderVoid'
  | 'purchaseOrderFreightRead'
  | 'purchaseOrderFreightCreate'
  | 'purchaseOrderFreightUpdate'
  | 'purchaseOrderFreightDelete'
  | 'purchaseOrderLineItemRead'
  | 'purchaseOrderLineItemCreate'
  | 'purchaseOrderLineItemUpdate'
  | 'purchaseOrderLineItemDelete'
  | 'quoteRead'
  | 'quoteCreate'
  | 'quoteUpdate'
  | 'quoteDelete'
  | 'quoteAccept'
  | 'quoteClone'
  | 'quoteConvert'
  | 'quoteReject'
  | 'quoteRestore'
  | 'quoteRevertToOpen'
  | 'quoteSend'
  | 'quoteVoid'
  | 'quoteLineItemRead'
  | 'quoteLineItemCreate'
  | 'quoteLineItemUpdate'
  | 'quoteLineItemDelete'
  | 'salesOrderRead'
  | 'salesOrderCreate'
  | 'salesOrderUpdate'
  | 'salesOrderDelete'
  | 'salesOrderCustomerRead'
  | 'salesOrderFreightRead'
  | 'salesOrderFreightCreate'
  | 'salesOrderFreightUpdate'
  | 'salesOrderFreightDelete'
  | 'ticketFreightRead'
  | 'ticketFreightCreate'
  | 'ticketFreightUpdate'
  | 'ticketFreightDelete';
